// C:\Users\sergi\kadosh\kadosh-frontend\src\App.tsx

import { useEffect, useState } from "react";
import Usuario from "./pages/usuario/Usuario";
import UsuarioNovo from "./pages/usuarioNovo/UsuarioNovo";

interface Versiculo {
    n: number;
    t: string;
}
interface Passagem {
    id: string;
    livro: string;
    capitulo: number;
    versiculos: Versiculo[];
    reflexao: string;
}
interface UsuarioData {
    id: string;
    nome: string;
    ultimo_acesso: string;
    dias_consecutivos: number;
    passagem_atual_id: string;
    atribuicao_passagem: string;
}

export interface Payload {
    usuario: UsuarioData;
    passagem: Passagem;
}

const App = () => {
    // Captura o parâmetro ID da URL
    const queryParams = new URLSearchParams(window.location.search);
    const idParam = queryParams.get("ID") || queryParams.get("id");

    // Estados da aplicação
    const [loading, setLoading] = useState(true);
    const [payload, setPayload] = useState<Payload | null>(null);
    const [isNovoUsuario, setIsNovoUsuario] = useState(false);
    const [hasError, setHasError] = useState(false); // Novo estado para erros

    // Passo 1: Verifica a existência do usuário assim que o app é montado
    useEffect(() => {
        if (!idParam) return;

        const verificarUsuario = async () => {
            try {
                const response = await fetch(
                    process.env.REACT_APP_BASE_URL_API || "",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: idParam }),
                    },
                );

                if (response.status === 404) {
                    // Usuário não existe, direciona para tela de cadastro
                    setIsNovoUsuario(true);
                } else if (response.ok) {
                    // Usuário existe, salva o payload
                    const data = await response.json();
                    setPayload(data);
                } else {
                    // Erros do tipo 500, etc.
                    console.error("Erro na API ao buscar usuário.");
                    setHasError(true);
                }
            } catch (error) {
                console.error("Falha na comunicação com o servidor:", error);
                setHasError(true); // Erros de rede (ex: servidor offline)
            } finally {
                setLoading(false);
            }
        };

        verificarUsuario();
    }, [idParam]);

    // Passo 2: Função chamada pelo componente UsuarioNovo
    const handleCriarUsuario = async (nome: string) => {
        setLoading(true);
        setHasError(false); // Reseta o estado de erro ao tentar novamente
        try {
            const response = await fetch(
                process.env.REACT_APP_BASE_URL_API || "",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ id: idParam, nome }),
                },
            );

            if (response.ok) {
                const data = await response.json();
                setPayload(data);
                setIsNovoUsuario(false);
            } else {
                console.error("Erro ao criar o usuário.");
                setHasError(true);
            }
        } catch (error) {
            console.error("Falha na comunicação com o servidor:", error);
            setHasError(true);
        } finally {
            setLoading(false);
        }
    };

    // Renderizações Condicionais

    // 1. Sem ID na URL
    if (!idParam) {
        return (
            <div
                style={{
                    display: "flex",
                    height: "100vh",
                    width: "100vw",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fbfaf9",
                }}
            >
                <h1 style={{ color: "hsl(220 15% 25%)", fontSize: "24px" }}>
                    Erro! Página não encontrada.
                </h1>
            </div>
        );
    }

    // 2. Erro desconhecido (API fora do ar, erro 500, etc)
    if (hasError) {
        return (
            <div
                style={{
                    display: "flex",
                    height: "100vh",
                    width: "80vw",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fbfaf9",
                    padding: "0 24px",
                    textAlign: "center",
                }}
            >
                <p style={{ color: "hsl(220 10% 55%)" }}>
                    Ops! Ocorreu um erro ao carregar os dados. Tente novamente
                    mais tarde.
                </p>
            </div>
        );
    }

    // 3. Carregando dados da API
    if (loading) {
        return (
            <div
                style={{
                    display: "flex",
                    height: "100vh",
                    width: "100vw",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#fbfaf9",
                }}
            >
                <p style={{ color: "hsl(220 10% 55%)" }}>
                    Carregando sua experiência...
                </p>
            </div>
        );
    }

    // 4. Usuário retornou 404 - Renderiza página para capturar o nome
    if (isNovoUsuario) {
        return <UsuarioNovo onSubmit={handleCriarUsuario} />;
    }

    // 5. Sucesso na API (tanto busca quanto criação) - Renderiza a aplicação principal
    if (payload) {
        return <Usuario data={payload} />;
    }

    return null;
};

export default App;
